import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportAssistenciaTecnicaCompletoUseCase } from "../../../presentation/useCases/read/get_report_assistencia_tecnica_completo_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportAssistenciaTecnicaCompletoUseCase
 */

export class GetReportAssistenciaTecnicaCompletoUseCase implements IGetReportAssistenciaTecnicaCompletoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportAssistenciaTecnicaCompleto(
    requiredMimeType: ReportMimeType | null,
    idAssistenciaTecnica: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportAssistenciaTecnicaCompleto(requiredMimeType, idAssistenciaTecnica);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `assistencia_tecnica_completo_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
